<template>
    <b-container class="os-card">
      <h3 class="text-center mb-5">{{ $helpers.getMetaTitleText($route) }}</h3>
  <b-form class="container" @submit.stop.prevent="signup">
    <loading-anim v-if="$store.state.loading" :active="$store.state.loading" fullScreen></loading-anim>
    <b-alert show variant="danger" v-if="form.state.submitted && form.state.unauthorized"><div v-html="submitError"></div></b-alert>
    <b-alert show variant="danger" v-if="form.state.submitted && form.state.errors">{{$t('login.server-error')}}
    </b-alert>
    <b-row>
        <b-col sm="12" md="6" class="px-3">
    <b-form-group v-if="!inOpenlegal()">
      <b-form-input id="codPromotion" type="text" v-model="form.codPromotion" :placeholder="$t('signupOH.registerCodeEnt')" @input="resetForm()"></b-form-input>
      <!-- <b-form-invalid-feedback :state="form.codPromotion">{{ $t('signupOH.errors.enterCode') }}</b-form-invalid-feedback> -->
    </b-form-group>

     <b-form-group>
            <!-- <base-multiSelect id="lang" v-model="this.formSelectLang.selected" label="text" :placeholder="$t('signupOH.selectLanguageTxt')" :options="this.formSelectLang.options"></base-multiSelect> -->
            <v-select id="lang" v-model="formSelectLang.selected" persistent-hint multiple attach :getOptionLabel="option => $i18nHelpers.normalizeProp('name') === 'name.es' ?option.name.es : option.name.en " 
            :placeholder="$t('signupOH.selectLanguageTxt')" :options="this.formSelectLang.options">
            <template #option="option">
                <slot name="option" :option="option">
                </slot>
              </template>
              <template #no-options>
                  {{ $t('signupOH.no-options') }}
              </template>
                <template #open-indicator="{ attributes }">
          <span v-bind="attributes">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6">
                  <path id="Path_4_Copy" data-name="Path 4 Copy" d="M0,0,6,6,0,12Z" transform="translate(12) rotate(90)" fill="#8a8a8a"/>
                </svg>
            </span>
                </template>
            </v-select>
            <b-form-invalid-feedback v-if="form.trySubmit" :state="formSelectLang.selected != null">{{ $t('signupOH.errors.enterLang') }}</b-form-invalid-feedback>
          </b-form-group>
    <b-form-group>
      <b-form-input type="text" v-model="$v.form.name.$model" :placeholder="$t('signupOH.registerName')" :state="validateState('name')" @input="resetForm()"></b-form-input>
      <b-form-invalid-feedback v-if="form.trySubmit" :state="form.name != null && form.name != ''">{{ $t('signupOH.errors.enterName') }}</b-form-invalid-feedback>
    </b-form-group>

    <!-- <b-form-group>
      <b-form-input type="text" v-if="!visibleFormsByCheckCode" v-model="form.name" :placeholder="$t('signupOH.registerNameEducativeCenter')" :state="name" @input="resetForm()"></b-form-input>
      <b-form-invalid-feedback v-if="form.trySubmit" :state="form.name != null && form.name != ''">{{ $t('signupOH.errors.enterNameEducativeCenter') }}</b-form-invalid-feedback>
    </b-form-group> -->

    <b-form-group>
      <b-form-input type="text" v-model="$v.form.firstSurname.$model" :placeholder="$t('signupOH.registerSurname1')" :state="validateState('firstSurname')" @input="resetForm()"></b-form-input>
      <b-form-invalid-feedback v-if="form.trySubmit" :state="form.firstSurname != null && form.firstSurname != ''">{{ $t('signupOH.errors.enterSurname1') }}</b-form-invalid-feedback>
    </b-form-group>

    <b-form-group>
      <b-form-input type="text" v-model="$v.form.secondSurname.$model" :placeholder="$t('signupOH.registerSurname2')" :state="validateState('secondSurname')" @input="resetForm()"></b-form-input>
      <!-- <b-form-invalid-feedback v-if="form.trySubmit" :state="form.secondSurname != null && form.secondSurname != ''">{{ $t('signupOH.errors.enterSurname2') }}</b-form-invalid-feedback> -->
    </b-form-group>
    <b-form-group>
      <div id="genderForm">
      <span class="genderBirthdate">{{ $t('signupOH.birthDate') }}</span>
      </div>
    </b-form-group>
    <b-row class="align-items-center">
            <b-col sm="12" md="4" class="pr-3">
              <b-form-group>
                <base-select id="day" v-model="selectDayBirth.selected" :searchable="true" label="text" :placeholder="$t('signupOH.dayBirth')" :options="this.selectDayBirth.options"></base-select>
        <b-form-invalid-feedback v-if="form.trySubmit" :state="selectDayBirth.selected != null">{{ $t('signupOH.errors.enterDay') }}</b-form-invalid-feedback>
     </b-form-group>             
            </b-col>
            <b-col sm="12" md="4" class="pr-3">
    <b-form-group>
                <base-select id="month" v-model="selectMonthBirth.selected" :searchable="true" label="text" :placeholder="$t('signupOH.monthBirth')" :options="this.selectMonthBirth.options"></base-select>
        <b-form-invalid-feedback v-if="form.trySubmit" :state="selectMonthBirth.selected != null">{{ $t('signupOH.errors.enterMonth') }}</b-form-invalid-feedback>
     </b-form-group>             
            </b-col>
            <b-col sm="12" md="4" class="pr-3">
    <b-form-group>
                <base-select id="year" v-model="selectYearBirth.selected" :searchable="true" label="text" :placeholder="$t('signupOH.yearBirth')" :options="this.selectYearBirth.options"></base-select>
                <b-form-invalid-feedback v-if="form.trySubmit" :state="selectYearBirth.selected != null">{{ $t('signupOH.errors.enterBirthdate') }}</b-form-invalid-feedback>
    </b-form-group>
            </b-col>
            <b-form-invalid-feedback v-if="form.trySubmit" :state="isDate18orMoreYearsOld(form.birthDate)">{{ $t('signupOH.errors.birthdateMore18') }}</b-form-invalid-feedback>    
            <b-form-invalid-feedback v-if="form.trySubmit" :state="isDateReal(form.birthDate)">{{ $t('signupOH.errors.birthdateMustBeReal') }}</b-form-invalid-feedback>    
          </b-row>
    <b-form-group>
     <div id="genderForm">
            <span class="genderText">{{ $t('signupOH.genderSex') }}</span>
            <radio-button-gender v-model="form.gender" :errorMsg="$t('signupOH.errors.enterSex')"></radio-button-gender>
            <b-form-invalid-feedback v-if="form.trySubmit" :state="form.gender != null">{{ $t('signupOH.errors.enterSex') }}</b-form-invalid-feedback>
     </div>
    </b-form-group>


  </b-col>
        <b-col sm="12" md="6" class="px-3">
  <!-- <b-form-group>
      <base-datepicker v-model="$v.form.birthDate.$model" value-as-date :placeholder="$t('signupOH.birthDate')" :validator="form.birthDate"></base-datepicker>
      <b-form-invalid-feedback v-if="form.trySubmit" :state="form.birthDate != null">{{ $t('signupOH.errors.enterBirthdate') }}</b-form-invalid-feedback>
      <b-form-invalid-feedback v-if="form.trySubmit" :state="isDate18orMoreYearsOld(form.birthDate)">{{ $t('signupOH.errors.birthdateMore18') }}</b-form-invalid-feedback>
    </b-form-group> -->
    <b-form-group>
        <base-select id="country" :searchable="true" v-model="selectedCountry.selected" :placeholder="$t('signupOH.country')" :options="selectedCountry.options" :label="$i18nHelpers.normalizeProp('name')" valueProp="idCountry"  @change="reCallProvince" :errorMsg="$t('signupOH.errors.enterCountry')" :clearable="false"/>
            <!-- <base-select id="country" v-model="selectCountry.selected" :label="$i18nHelpers.normalizeProp('name')"
              :placeholder="$t('signupOH.country')" :options="selectCountry.options" valueProp="idCountry"></base-select> -->
        <b-form-invalid-feedback v-if="form.trySubmit" :state="selectedCountry.selected != null">{{ $t('signupOH.errors.enterCountry') }}</b-form-invalid-feedback>
     </b-form-group>

    <b-form-group>
      <base-select id="province" :searchable="true" v-model="selectProvince.selected" :placeholder="$t('signupOH.registerYourProvince')" :options="selectProvince.options" :label="$i18nHelpers.normalizeProp('name')" valueProp="id"></base-select>
      <b-form-invalid-feedback v-if="form.trySubmit" :state="selectProvince.selected != null">{{ $t('signupOH.errors.enterProvince') }}</b-form-invalid-feedback>
    </b-form-group>

    <b-form-group>
      <div class="dni">
      <b-form-input type="text" v-model="$v.form.nif.$model" :placeholder="$t('signupOH.registerNIF')" :state="validateState('nif')" @input="resetForm()"></b-form-input>
      <b-form-invalid-feedback v-if="form.trySubmit" :state="form.nif != null">{{ $t('signupOH.errors.enterNIF') }}</b-form-invalid-feedback>
      </div>
    </b-form-group>

    <b-form-group>
      <b-form-input type="text" v-model="$v.form.email.$model" :placeholder="$t('signupOH.registerEmail')" :state="validateState('email')" @input="resetForm()"></b-form-input>
      <b-form-invalid-feedback v-if="form.trySubmit" :state="form.email != null">{{ $t('signupOH.errors.enterEmail') }}</b-form-invalid-feedback>
    </b-form-group>
     
    <b-form-group>
      <b-form-input type="text" v-model="$v.form.emailConfirmation.$model" :placeholder="$t('signupOH.confirmEmail')" :state="validateState('emailConfirmation')" @input="resetForm()"></b-form-input>
      <b-form-invalid-feedback v-if="form.trySubmit" :state="form.emailConfirmation != null">{{ $t('signupOH.errors.enterConfirmEmail') }}</b-form-invalid-feedback>
      <b-form-invalid-feedback v-if="form.trySubmit" :state="form.emailConfirmation == form.email">{{ $t('signupOH.errors.sameEmails') }}</b-form-invalid-feedback>
    </b-form-group>

    <b-row class="align-items-center">
            <b-col sm="12" md="5" class="pr-3">
              <b-form-group>
        <base-select id="prefix" v-model="selectPrefix.selected" :searchable="true" :placeholder="$t('signupOH.registerPhonePrefix')" :options="selectPrefix.options" :label="$i18nHelpers.normalizeProp('prefixAndCountry')" valueProp="phonePrefix"/>
        <b-form-invalid-feedback v-if="form.trySubmit" :state="selectPrefix.selected != null">{{ $t('signupOH.errors.enterPhonePrefix') }}</b-form-invalid-feedback>
     </b-form-group>             
            </b-col>
            <b-col sm="12" md="7" class="pr-3">
              <b-form-group>
      <b-form-input type="number" v-model="$v.form.phoneNumber.$model" :placeholder="$t('signupOH.registerPhoneNumber')" :state="validateState('phoneNumber')" @input="resetForm()"></b-form-input>
      <b-form-invalid-feedback v-if="form.trySubmit" :state="form.phoneNumber != null">{{ $t('signupOH.errors.enterPhoneNumber') }}</b-form-invalid-feedback>
    </b-form-group>
            </b-col>
          </b-row>
    <b-form-group>
          <base-select id="discovery" v-model="selectDiscovery.selected" :searchable="true" label="text" :placeholder="$t('signupOH.selectDiscovery')" :options="this.selectDiscovery.options"></base-select>
          <b-form-invalid-feedback v-if="form.trySubmit" :state="selectDiscovery.selected != null">{{ $t('signupOH.errors.enterDiscoveryType') }}</b-form-invalid-feedback>
        </b-form-group>
    <b-form-group>

    <base-checkbox v-model="form.termsAccepted">
            <span v-html="$t('signupOH.accept-terms-patient')"></span>
            <b-form-invalid-feedback v-if="form.trySubmit" :state="form.termsAccepted === true">{{ $t('signupOH.errors.termsAccepted') }}</b-form-invalid-feedback>
    </base-checkbox>
    
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="align-items-center justify-content-center pb-3 text-center">
      <VueRecaptcha
      :sitekey="siteKey"
      :load-recaptcha-script="true"
      @verify="handleSuccess"
      @error="handleError"
    ></VueRecaptcha>
    <b-form-invalid-feedback v-if="form.trySubmit" :state="form.captcha == true">{{ $t('signupOH.errors.captcha') }}</b-form-invalid-feedback>
    </b-row>

    <b-button type="submit" variant="primary" style="width: 100%">
      {{ $t('signupOH.signup-submit') }}
    </b-button>
    <hr>

        <span>{{ $t('signUp.already-registered') }}, <a style="cursor: pointer" class="log-in-a" @click="goLogin">{{ $t('sign-up-href') }}</a>.</span>

  <b-modal  v-model="visibleModalBusiness" title-class="title-modal" centered no-close-on-esc no-close-on-backdrop hide-header-close>
    <div class="text-center">
      <div style="margin-bottom:1rem">
      <h6 style="margin-bottom: 0rem !important;">{{ $t('signupOH.modalBusiness') }} </h6>
      </div>
      <div style="margin-bottom:1rem">
      <h6>{{ $t('signupOH.modalBusiness2') }}</h6>
      </div>
    </div>
    <template #modal-footer>
      <b-button :variant="okBtnVariant" @click="builtInOkFnBusiness()">
      {{ $t('signupOH.continue') }}      
      </b-button>
      <b-button :variant="cancelBtnVariant" @click="builtInCancelFnBusiness()">
       {{ $t('signupOH.cancel') }}      
      </b-button>
    </template>
  </b-modal>
  </b-form>
</b-container>
</template>

<script>
import { BForm, BFormGroup, BButton, BFormInvalidFeedback, BFormInput, BAlert, BModal } from 'bootstrap-vue'
import BaseCheckbox from '@/components/base/forms/BaseCheckbox'
import BaseDatepicker from '@/components/base/forms/BaseDatepicker'
import RadioButtonGender from '../base/forms/RadioButtonGender.vue'
import '@/plugins/vue-select'
import { validationMixin } from 'vuelidate'
import { required, requiredIf, minLength, numeric, email, sameAs } from 'vuelidate/lib/validators'
import { gender, phone, onlyTrue, afterToday, afterDate } from '@/plugins/customValidators'
import { VueRecaptcha } from 'vue-recaptcha'
import LoadingAnim from '@/components/utils/LoadingAnim'
import accountMixin from '@/mixins/account.mixin'
import { recaptcha } from '@/constants/recaptcha'
import geographyRepository from '@/repositories/GeographyRepository'
import languagesRepository from '@/repositories/LanguageRepository'
import { inOpenlegal } from '@/constants/platformNames'
import { getDefaultCountryId, getDefaultPhonePrefix } from '@/helpers/global.helpers'

export default {
  name: 'sign-up-form',
  mixins: [validationMixin, accountMixin],
  components: {
    BForm,
    VueRecaptcha,
    BModal,
    BFormGroup,
    LoadingAnim,
    BButton,
    BFormInvalidFeedback,
    BFormInput,
    BAlert,
    'base-select': () => import('@/components/base/forms/BaseSelect'),
    'base-multiSelect': () => import('@/components/base/forms/BaseMultiSelect'),
    BaseCheckbox,
    'radio-button-gender': RadioButtonGender,
    BaseDatepicker
    },
  props: {
    callback: {
      type: Function,
      required: false
    },
    role: {
      type: String,
      required: false
    }
  },
  data () {
    return {
			inOpenlegal,
      siteKey: recaptcha,
      visibleModal: false,
      visibleModalBusiness: false,
      visibleIfCountrySpain: true,
      form: {
        captcha: false,
        trySubmit: false,
        codPromotion: null,
        name: null,
        firstSurname: null,
        secondSurname: null,
        nif: null,
        gender: null,
        email: null,
        birthDate: null,
        dayBirth: null,
        monthBirth: null,
        yearBirth: null,
        emailConfirmation: null,
        phoneNumber: null,
        languages: null,
        countryId: null,
        stateId: null,
        prefixList: [],
        prefix: null,
        phonePrefix: null,
        state: {
          waiting: false,
          unauthorized: false,
          errors: false,
          submitted: false
        },
        termsAccepted: false

      },
      formSelectLang: {
        options: [],
        selected: null
      },
      binRadioGroup: {
        selected: null
      },
      selectedCountry: {
        selected: null,
        options: []
      },
      selectProvince: {
        selected: null,
        options: []
      },
      selectDiscovery: {
        selected: null,
        options: [
        { value: '1', text: this.inOpenlegal() ? this.$t('signupDiscovery.title1-openlegal') : this.$t('signupDiscovery.title1') },
          { value: '2', text: this.inOpenlegal() ? this.$t('signupDiscovery.title2-openlegal') : this.$t('signupDiscovery.title2') },
          { value: '3', text: this.inOpenlegal() ? this.$t('signupDiscovery.title3-openlegal') : this.$t('signupDiscovery.title3') },
          { value: '4', text: this.$t('signupDiscovery.title4') },
          { value: '5', text: this.$t('signupDiscovery.title5') },
          { value: '6', text: 'Email' },
          { value: '7', text: this.$t('signupDiscovery.title7') },
          { value: '8', text: this.$t('signupDiscovery.title8') },
          { value: '9', text: this.$t('signupDiscovery.title9') },
          { value: '10', text: this.$t('signupDiscovery.title10') },
          { value: '11', text: this.$t('signupDiscovery.title11') }
        ]
      },
      selectPrefix: {
        selected: null,
        options: []
      },
      selectDayBirth: {
        selected: null,
        options: [
        { value: '01', text: '01' },
        { value: '02', text: '02' },
        { value: '03', text: '03' },
        { value: '04', text: '04' },
        { value: '05', text: '05' },
        { value: '06', text: '06' },
        { value: '07', text: '07' },
        { value: '08', text: '08' },
        { value: '09', text: '09' },
        { value: '10', text: '10' },
        { value: '11', text: '11' },
        { value: '12', text: '12' },
        { value: '13', text: '13' },
        { value: '14', text: '14' },
        { value: '15', text: '15' },
        { value: '16', text: '16' },
        { value: '17', text: '17' },
        { value: '18', text: '18' },
        { value: '19', text: '19' },
        { value: '20', text: '20' },
        { value: '21', text: '21' },
        { value: '22', text: '22' },
        { value: '23', text: '23' },
        { value: '24', text: '24' },
        { value: '25', text: '25' },
        { value: '26', text: '26' },
        { value: '27', text: '27' },
        { value: '28', text: '28' },
        { value: '29', text: '29' },
        { value: '30', text: '30' },
        { value: '31', text: '31' }
        ]
      },
      selectMonthBirth: {
        selected: null,
        options: [
        { value: '01', text: this.$t('signupMonth.january') },
        { value: '02', text: this.$t('signupMonth.february') },
        { value: '03', text: this.$t('signupMonth.march') },
        { value: '04', text: this.$t('signupMonth.april') },
        { value: '05', text: this.$t('signupMonth.may') },
        { value: '06', text: this.$t('signupMonth.june') },
        { value: '07', text: this.$t('signupMonth.july') },
        { value: '08', text: this.$t('signupMonth.august') },
        { value: '09', text: this.$t('signupMonth.september') },
        { value: '10', text: this.$t('signupMonth.october') },
        { value: '11', text: this.$t('signupMonth.november') },
        { value: '12', text: this.$t('signupMonth.december') }
        ]
      },
      selectYearBirth: {
        selected: null,
        options: []
      },
      errors: {
        email: null,
        password: null
      },
      submitError: null
    }
  },
  validations: {
    form: {
      name: {
        required
      },
      firstSurname: {
        required
      },
      secondSurname: {
      },
      email: {
        required,
        email
      },
      emailConfirmation: {
        required,
        email,
        sameAsEmail: sameAs('email')
      },
      gender: {
        required,
        gender
      },
      countryId: {
        required,
        numeric
      },
      stateId: {
        required,
        numeric
      },
      birthDate: {
        required,
        isDate18orMoreYearsOld (val) {
          return new Date(new Date(val).getFullYear() + 18, new Date(val).getMonth() - 1, new Date(val).getDay()) <= new Date()
        },
        maxValue (val) {
          return new Date(val) < new Date()
        },
        minValue (val) {
          return new Date(val) > new Date(1900, 0, 1)
        }
      },
      companyCode: {
        required
        /* validCompanyCode () { return this.companyCodeIsValid } */
      },
      nif: {
        required,
        validateNIF (dni) {
          return this.$validators.validateNIF(dni)
        }
      },
      prefixCountry: {
        required
      },
      phoneNumber: {
        required,
        phone
      },
      reservationNumber: {
        required: requiredIf(() => {
          return !this.codeIsGeneric
        })
      },
      employeeGroup: {
        required: requiredIf(() => {
          return !this.employeeGroupFieldIsVisible
        }),
        numeric
      },
      reservationFromDate: {
        required: requiredIf(() => {
          return !this.isTravelCompany
        })
      },
      reservationToDate: {
        required: requiredIf(() => {
          return !this.isTravelCompany
        }),
        afterToday,
        afterDate: afterDate('reservationFromDate')
      },
      employeeNumber: {
        required: requiredIf(() => {
          return !this.employeeNumberFieldIsVisible
        })
      },
      languages: {
        required,
        minLength: minLength(1)
      },
      termsAccepted: {
        required,
        onlyTrue
      }
    }
  },
  methods: {
    // checkCode () {
    //   this.$api.get(`/CheckCodeType/${this.form.codPromotion}`).then((response) => {
    //   if (response === 1) {
    //     this.form.visibleFormsByCheckCode = true
    //   } else if (response === 2) {
    //     this.form.visibleFormsByCheckCode = false
    //   } else if (response === 7) {
    //     this.form.visibleFormsByCheckCode = true
    //   } else {
    //     this.form.visibleFormsByCheckCode = true
    //   }
    // })
    // },
    isDate18orMoreYearsOld () {
      this.form.birthDate = `${this.selectYearBirth.selected}${'-'}${this.selectMonthBirth.selected}${'-'}${this.selectDayBirth.selected}`
       if (new Date(new Date(this.form.birthDate).getFullYear() + 18, new Date(this.form.birthDate).getMonth() - 1, new Date(this.form.birthDate).getDay()) <= new Date()) {
        return true
       } else {
        return false
      }
     },
     isDateReal (val) {
       if (!(val.includes('04-31') || val.includes('02-30') || val.includes('02-31') ||
       val.includes('06-31') || val.includes('09-31') || val.includes('11-31'))) {
        return true
       } else {
        return false
      }
     },
    handleError: function () {
      this.form.captcha = false
      },
     handleSuccess: function () {
       this.form.captcha = true
      },
    validateState (prop) {
      /* eslint-disable no-unused-vars */
      const { $dirty, $error } = this.$v.form[prop]
      return $dirty ? !$error : null
    },
    getTermsFormState () {
      return !this.form.state.submitted ? this.termsAccepted : this.termsAccepted === true
    },
    builtInOkFn () {
      this.visibleModal = false
      // this.$router.go(this.$router.currentRoute)
    },
    builtInOkFnBusiness () {
      this.visibleModalBusiness = false
      window.location = this.$helpers.get360AppUrl()
    },
    builtInCancelFnBusiness () {
      this.visibleModalBusiness = false
    },
    validationDateOlderThan18: function (date) {
        if (date != null) {
             var today = new Date()
             var dd = date.split('/')[0]
             var mm = date.split('/')[1] - 1
             var yyyy = date.split('/')[2]

             var theDate = new Date(yyyy, mm, dd)
            if (((new Date() - theDate) < 568026791427) || theDate >= today) {
              return false
            } else {
           return true
        }
       } else {
         return false
     }
    },
    validateText: function (text) {
      var re = /^[A-Za-zÀ-ÖØ-öø-ÿ]+$/i
      if (!re.test(text)) {
        return false
      } else {
        return true
      }
    },
    reCallProvince: function () {
      this.selectProvince.selected = null
      this.$api.get(`/states/${this.selectedCountry.selected}`).then((response) => {
      this.selectProvince.options = response.data
    })
    this.showDni()
    },
    formValid: function () {
      this.form.birthDate = `${this.selectYearBirth.selected}${'-'}${this.selectMonthBirth.selected}${'-'}${this.selectDayBirth.selected}`
      return (this.form.name != null && this.form.name !== '') &&
          (this.form.firstSurname != null && this.form.firstSurname !== '') &&
          (this.selectedCountry != null && this.form.selectedCountry !== '') &&
          (this.selectedCountry.selected === 28 ? this.form.nif !== null && this.form.nif !== '' : true) &&
          (this.selectProvince != null && this.form.selectProvince !== '') &&
          (this.selectDiscovery != null && this.form.name !== '') &&
          (this.form.email != null && this.form.email !== '') &&
          (this.form.termsAccepted !== null && this.form.termsAccepted !== false) &&
          (this.form.captcha !== null && this.form.captcha !== false) &&
          (this.form.emailConfirmation != null && this.form.emailConfirmation !== '') &&
          (this.form.email === this.form.emailConfirmation) &&
          this.selectPrefix.selected != null &&
          (this.form.gender !== null) &&
          (this.form.termsAccepted !== false) &&
          this.form.phoneNumber != null &&
          this.formSelectLang.selected != null &&
          (this.selectYearBirth.selected != null) &&
          (this.selectMonthBirth.selected != null) &&
          (this.selectDayBirth.selected != null) &&
          (this.form.birthDate != null) &&
          this.isDate18orMoreYearsOld(this.form.birthDate) &&
          this.isDateReal(this.form.birthDate) &&
          this.validationDateOlderThan18(this.form.birthDate) &&
          /^\d{6,14}$/.test(this.form.phoneNumber)
    },
    signup: function () {
      const _this = this
      this.resetForm()
      this.form.trySubmit = true
      var maleRole = false
      if (this.form.gender === 'H') maleRole = true
      this.form.state.submitted = true
      this.$v.form.$touch()
      /* this.resetForm()
      this.form.state.submitted = true */
      this.form.state.waiting = true
      if (this.formValid() !== false) {
        var lng = []
      this.formSelectLang.selected.map((x, i) => {
        lng.push(x.id)
      })
        this.$api.post('/CreateUser',
        {
          ClientReturnUrl: encodeURIComponent(_this.$route.query.returnUrl || (_this.$route.query.ReturnUrl || null)),
          role: 'Paciente',
          male: maleRole,
          portal: this.portal,
          female: !maleRole,
          firstName: this.form.name.trim(),
          lastName1: this.form.firstSurname.trim(),
          lastName2: this.form.secondSurname != null ? this.form.secondSurname.trim() : null,
          idCountry: this.selectedCountry.selected,
          idProvince: this.selectProvince.selected,
          codPromotion: this.form.codPromotion,
          dni: this.form.nif,
          idHowToMeet: this.selectDiscovery.selected,
          email: this.form.email,
          prefix: this.selectPrefix.selected,
          phone: this.form.phoneNumber,
          languages: lng,
          bornDate: this.form.birthDate
          }).then((response) => {
          this.defaultLoginCallback(response)
        }).catch(function () {
          _this.form.state.errors = true
          _this.form.state.waiting = false
          return this.$router.push({ path: '/cuenta/registro-correcto', query: { email: this.form.email.trim(), confirmSucessful: false } })
        })
      } else {
        _this.form.state.waiting = false
      }
    },
    defaultLoginCallback (response) {
      if (response.data) {
        switch (response.data.status) {
          case 200:
            // window.location = response.data.url
            if (response.data.data === 'business') {
             this.visibleModalBusiness = true
            } else {
              return this.$router.push({ path: '/cuenta/registro-correcto', query: { email: this.form.email.trim(), confirmSucessful: true } })
            }
            break
          case 403:
            this.submitError = response.data.message
            this.form.state.unauthorized = true
            this.form.state.waiting = false
            break
          case 400:
            if (this.inOpenlegal()) {
              this.submitError = this.$t('error-alreadyregister-openlegal')
            } else {
              this.submitError = this.$t('error-alreadyregister')
            }
            this.form.state.unauthorized = true
            this.form.state.waiting = false
            break
          case 405:
            this.submitError = this.$t('invalidPromotionCode')
            this.form.state.unauthorized = true
            this.form.state.waiting = false
            break
          default:
            this.form.state.errors = true
            this.form.state.waiting = false
            break
        }
      } else {
        this.form.state.errors = true
        this.form.state.waiting = false
      }
    },
    resetForm: function () {
      this.form.state.submitted = false
      this.form.state.waiting = false
      this.form.state.unauthorized = false
      this.form.state.errors = false
    },
    showDni () {
       const dni = document.querySelector('.dni')
    if (this.selectedCountry.selected !== 28) {
      dni.classList.add('hide')
    } else {
      dni.classList.remove('hide')
    }
    }
  },
  computed: {
    formValid2: function () {
      return this.emailValidation &&
          (this.form.name != null && this.form.name !== '') &&
          (this.form.firstSurname != null && this.form.name !== '') &&
          (this.selectedCountry != null && this.form.name !== '') &&
          (this.selectProvince != null && this.form.name !== '') &&
          (this.form.name != null && this.form.name !== '') &&
          (this.selectDiscovery != null && this.form.name !== '') &&
          (this.form.email != null && this.form.name !== '') &&
          this.selectPrefix.selected != null &&
          this.form.phoneNumber != null &&
          this.formSelectLang.selected != null &&
          this.form.birthDate != null
    },
    emailValidation: function () {
      return this.$validators.validate(this.form.email, ['required', 'email'], this.form.state.submitted)
    },
    passwordValidation: function () {
      return this.$validators.validate(this.form.password, ['required'], this.form.state.submitted)
    }
  },
  mounted () {
      languagesRepository.getLanguages().then((response) => {
      this.formSelectLang.options = response.data
    })
    geographyRepository.getCountries().then((response) => {
      this.selectedCountry.options = response.data
      this.selectPrefix.options = response.data
      // console.log(this.$i18nHelpers.getNormalizedLocale())
      // console.log(this.selectPrefix.selected)
      this.selectedCountry.selected = getDefaultCountryId()
      this.selectPrefix.selected = getDefaultPhonePrefix()
      const selectedCountry = this.selectedCountry.options.find(country => country.idCountry === selectedCountry.selected)
      this.form.countryId = selectedCountry.idCountry
      this.form.prefixCountry = selectedCountry

			geographyRepository.getStatesByCountry(this.form.countryId).then((response) => {
				this.selectProvince.options = response.data
			})
    })
  }
}
</script>

<style lang="scss" scoped>
.os-card {
  @include desktop {
    padding: 3rem 6rem;
  }
  @include desktop-sm {
    padding: 3rem 6rem;
  }
  @include tablets {
    padding: 3rem 6rem;
  }
  @include mobile {
    padding: 3rem 1rem;
    h3{
      font-size: 1.3rem;
    }
  }
  border-radius: $border-radius !important;
  box-shadow: $custom-shadow;
  margin: {
    bottom: 2rem;
  }
}
.log-in-a{
  color: $blue !important
}
  span .vs__selected{
    margin-left: 1%;
    font-size: 0.8rem;    
  }

  .v-select {
    // margin: 2% 0px 2% 0px !important;
    margin-top: 0px !important;
    margin-bottom: 0px !important;

  }
  .vs__selected{
  margin-left: 1rem !important;
  padding: 0 0.8em !important;
  }

  .form-group{
    margin: 2% 0px 2% 0px !important;
  }

  div .v-select .vs--unsearchable{
    margin: 0px !important;
  }

  .vs__selected, .vs__search, .vs__search:focus {
  margin-left: 1rem !important;
  
  }

  .v-select .vs--single .vs--unsearchable{
        margin: 0px !important;
  }

  div .mt-3, button, p, fieldset, .v-select, .custom-checkbox, .my-3 {
      margin-top: 0rem !important;
  }

  #lang{
      margin-top: 0rem !important;
      margin-bottom: 0rem !important;
  }
    #prefix{
      margin-top: 0rem !important;
      margin-bottom: 0rem !important;
  }
    #country{
      margin-top: 0rem !important;
      margin-bottom: 0rem !important;
  }
    #province{
      margin-top: 0rem !important;
      margin-bottom: 0rem !important;
  }

  #genderForm{
    // display: inline-flex;
    text-align: left !important;
  }

  .genderText{
    float: left;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.6;
    color: #495057;
    padding: 0rem 2.2rem;
  }
.genderBirthdate{
    float: left;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.6;
    color: #495057;
    padding: 0rem 2.2rem;
    padding-top: 0.5rem;
  }
  
  .row {
    display: flex;
    flex-wrap: wrap;
    // margin-right: auto !important;
    // margin-left: auto !important;
  }

  @media (max-width: 1024px) {
    .Body1_OH-sm{
    display:block !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    }
  }

.dni.hide {
  display: none;
}

  .headerMenu {
    margin: 22px 133px 0px 4% ;
    // line-height: 2.70 !important;
    // display: block !important;
    // @media (max-width: 1024px) {
    //   margin: auto !important;
    // }
  }

  div  .Body3_rightCol{
      padding-right: 0px !important;
      padding-left: 0px !important;      
  }

  .Body2_OH {
    margin: 5% 0% 0% 12% !important;
}
.Body3_div {
    display: block;
    padding: 8% 0px 8% 10% !important;;
    background-color: #1D1D1E;
    opacity: 87%;
    margin: 0px 0% 0px 0px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/forms/SignupForm.vue